import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';
import { openUrl } from 'frontend-utils/utils/url/open-url';
import type { BenchmarkInsightCompetitorsCompetitor } from 'lumen/models';
import type AjaxService from 'lumen/services/ajax';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class BenchmarkInsightBeniCompetitorsServiceService extends Service {
  @service declare ajax: AjaxService;
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  @tracked hoveredCompetitor: BenchmarkInsightCompetitorsCompetitor | null =
    null;
  @tracked lastHoveredCompetitor: BenchmarkInsightCompetitorsCompetitor | null =
    null;

  handleHover(competitor?: BenchmarkInsightCompetitorsCompetitor): void {
    this.hoveredCompetitor = competitor ?? null;

    if (competitor) {
      this.lastHoveredCompetitor = competitor;
    }
  }

  redirectToSource(competitor: BenchmarkInsightCompetitorsCompetitor): void {
    const fromDate = this.hotelAndMarketService.getLocalTime();
    const ota = '';
    const hotelInfoId = competitor.id;
    const hotelId = this.hotelAndMarketService.hotel?.id;
    const { isTripadvisorRebranding } = this.hotelAndMarketService.hotel ?? {};
    const period = {
      fromDate,
      los: 1,
    };
    const maxPersons = 2;
    const source = 'competitors';
    const city = false;

    const link = generateOtaLink(
      ota,
      // @ts-expect-error: Argument of type 'string | number | null' is not assignable to parameter of type 'string | number'.
      hotelInfoId,
      hotelId,
      isTripadvisorRebranding,
      period,
      maxPersons,
      source,
      city,
    );

    openUrl(`${this.ajax?.host}${link}&direct=true`);
  }
}

declare module '@ember/service' {
  interface Registry {
    'benchmark-insight/beni-competitors-service': BenchmarkInsightBeniCompetitorsServiceService;
  }
}
